/**
 * Outil « Graphes et Markov » (Boîte à outils, Tle maths expertes).
 *
 * Deux regards sur une matrice carrée : la matrice d'adjacence d'un graphe
 * (Mᵏ compte les chemins de longueur k, qu'on voit un par un) et la matrice
 * de transition d'un graphe probabiliste (πₙ = π₀Pⁿ converge vers l'état
 * stable π = πP, calculé en fractions exactes).
 */

import { useState } from 'react';
import type { ToolProps } from '../../tool-types';
import { Segmented } from '../../ui/controls';
import { MarkovMode } from './markov-mode';
import { PathsMode } from './paths-mode';

type Mode = 'paths' | 'markov';

export function MarkovGraphTool({ onSend, sendCost }: ToolProps) {
  const [mode, setMode] = useState<Mode>('markov');
  return (
    <div className="space-y-4">
      <Segmented
        ariaLabel="Ce qu’on regarde"
        value={mode}
        options={[
          { value: 'markov', label: 'Chaîne de Markov' },
          { value: 'paths', label: 'Chemins et chaînes' },
        ]}
        onChange={setMode}
      />
      {mode === 'markov' ? <MarkovMode onSend={onSend} sendCost={sendCost} /> : <PathsMode />}
    </div>
  );
}
